/**
 * Sanitize any phone input into E.164 format (+1XXXXXXXXXX for US/CA)
 * Handles: (323) 972-8093, 323-972-8093, 3239728093, 13239728093,
 *          +13239728093, 1(323)972-8093, +1 (323) 972-8093, etc.
 */
export function toE164(input: string): string {
  const digits = input.replace(/\D/g, '')

  if (digits.length === 10) return `+1${digits}`
  if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`
  if (digits.length > 10 && input.includes('+')) return `+${digits}`

  return `+${digits}`
}

/**
 * Format a phone number for display: +1 (XXX) XXX-XXXX
 */
export function formatPhoneDisplay(input: string): string {
  const digits = input.replace(/\D/g, '')

  if (digits.length === 0) return ''

  // Handle with or without country code
  const national = digits.length === 11 && digits.startsWith('1')
    ? digits.slice(1)
    : digits.length === 10
      ? digits
      : digits

  if (national.length <= 3) return `+1 (${national}`
  if (national.length <= 6) return `+1 (${national.slice(0, 3)}) ${national.slice(3)}`
  return `+1 (${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6, 10)}`
}

/**
 * Check if a phone string has enough digits to be valid
 */
export function isValidPhoneInput(input: string): boolean {
  const digits = input.replace(/\D/g, '')
  return digits.length >= 10 && digits.length <= 11
}
